import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
import VoiceOverOffIcon from "@mui/icons-material/VoiceOverOff";
import {
  APP_TOP_BAR_ACTION_HIT_PX,
  APP_TOP_BAR_ACTION_ICON_PX,
} from "layout/appTopBarLayout";
import { usePageGuideContextOptional } from "./PageGuideContext";

/**
 * Title-bar PageGuide control: play / stop the page introduction.
 * Hidden when the platform kill switch is off.
 * Idle coaching lives in Settings, not here.
 */
function PageGuideHeaderToggle() {
  const ctx = usePageGuideContextOptional();
  if (!ctx || !ctx.ready) return null;
  if (!ctx.platformEnabled) return null;

  const offered = ctx.hasIntroduction === true || ctx.pageOffered === true;
  const playing = ctx.introPlaying === true;

  let title = "PageGuide introduction not available on this page";
  let dataState = "not-offered";
  if (offered && playing) {
    title = "Stop page introduction";
    dataState = "playing";
  } else if (offered) {
    title = "Play page introduction";
    dataState = "ready";
  }

  const handleClick = () => {
    if (!offered) return;
    if (playing) {
      ctx.stopIntroduction?.();
      return;
    }
    void ctx.playIntroduction?.();
  };

  return (
    <Tooltip title={title}>
      <span>
        <IconButton
          type="button"
          aria-label={title}
          onClick={handleClick}
          disabled={!offered}
          data-testid="pageguide-header-toggle"
          data-state={dataState}
          sx={{
            width: APP_TOP_BAR_ACTION_HIT_PX,
            height: APP_TOP_BAR_ACTION_HIT_PX,
            flexShrink: 0,
            color: offered && !playing ? "primary.main" : "text.secondary",
          }}
        >
          {offered ? (
            <RecordVoiceOverIcon sx={{ fontSize: APP_TOP_BAR_ACTION_ICON_PX }} />
          ) : (
            <VoiceOverOffIcon sx={{ fontSize: APP_TOP_BAR_ACTION_ICON_PX }} />
          )}
        </IconButton>
      </span>
    </Tooltip>
  );
}

export default PageGuideHeaderToggle;
